export function initPlayer(playerId, videoId) {
    window.exp360.init({
        onReady: () => {
            setupPlayerSimple(playerId, videoId);
        }
    });
}

export function setupPlayerSimple(playerDomId, videoId) {
    try {
        window.exp360player = window.EXP360VRPlayer.create(
            playerDomId,
            videoId,
            {
                autoplay: true,
                controlHint: true,
                // onPlayerReady: () => {console.log("the player is ready")},
                // onPlayerCreated: () => {console.log("player was created")},
                // onContentFinished: () => {console.log("content has finished")},
                autorotate: true,
                autorotateSpeed: 6,
                autorotateDelay: 2500,
            }
        );
    }
    catch (e) {
        console.log("EXP360VRPlayer create function failed", e);
    }
}

export function destroyPlayer() {
    if(window.exp360player) {
        window.exp360player.destroy();
        window.exp360player = null;
    }
}


export function open360content(videoId) {
    window.exp360player.openContent(videoId);
}